import {AddView_Group} from "../../../../../../../../core/gd-ui/add-view/@types"
import {ProjectSystemType} from "../../../../../../../../core/model2/project/types"
import addView_projectTagConfig from "./new-tag-config"
import addView_projectConfig from "./new-project-views-config"

export default function getNewProjectViewItemsGrouped(projectId: ID):AddView_Group[] {

    switch (gd.projectViews.project.systemType) {
        case ProjectSystemType.TAG:
            return addView_projectTagConfig()

        default:
            return addView_projectConfig(projectId)
    }
}
